import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=f2ca28c8&scoped=true"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"
import style0 from "./Reception.vue?vue&type=style&index=0&id=f2ca28c8&prod&scoped=true&lang=scss"
import style1 from "./Reception.vue?vue&type=style&index=1&id=f2ca28c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ca28c8",
  null
  
)

export default component.exports